<template>
  <div class="w-full h-auto bg-[#1A1A1A]">

    <!-- Desktop/Tablet -->
    <div v-if="!isMobile" class="w-full h-auto">
      <div @scroll-to-section="scrollTo"
        class="fixed top-[1.3vw] px-[0.6vw] w-[83vw] mx-[8.5vw] h-[3.65vw] bg-[#00404B30] backdrop-blur-[2.3vw] rounded-full flex flex-row justify-between z-[999] items-center">
        <div class="" @click="scrollTo('homePage')">
          <img src="../src/assets/img/Desktop/LogoNav/1.webp" alt="" class="h-[2.7vw] hover:cursor-pointer">
        </div>
        <div class="w-[20.3vw] flex flex-row justify-between">
          <!-- <p class="text-[1.05vw] text-white hover:cursor-pointer font-bold font-league">
            Story
          </p> -->
          <p class="text-[1.05vw] text-white hover:cursor-pointer font-bold font-league"
            @click="scrollTo('conquer-world')">
            Feature
          </p>
          <p class="text-[1.05vw] text-white hover:cursor-pointer font-bold font-league" @click="scrollTo('homePage')">
            Gameplay
          </p>
          <p class="text-[1.05vw] text-white hover:cursor-pointer font-bold font-league" @click="scrollTo('community')">
            Community
          </p>
        </div>
        <img src="./assets/img/Desktop/LogoNav/ButtonPlayNow.png" alt="" class="h-[2.7vw] hover:cursor-pointer"  
        @click="openWebLink('https://play.idle-glory.io/')">
      </div>
      <!-- Content page -->
      <div class="w-full h-auto flex flex-col">
        <HomeDesk id="homePage" />
        <TopIdlePowers />
        <DeepStrategy />
        <SummonLegend />
        <ConquerWorld id="conquer-world" />
        <FirestormArena id="community" />
        <DesktopFooter />
      </div>
    </div>
    <!-- Mobile -->
    <div v-if="isMobile" class="w-full h-auto">
      <div class="w-full h-auto flex flex-col bg-[#171717] items-center justify-center">
        <!-- navbar mobile -->
        <div ref="navbarClose"
          class="fixed top-[3vw] transition-all duration-500 ease-in-out backdrop-blur-ip w-[95vw] rounded-[3vw] px-[2.8vw] flex bg-[#00191D30] backdrop-blur-[6vw] py-[1.4vw] flex-row justify-between z-50">
          <img src="./assets/img/Desktop/LogoNav/1.webp" @click="scrollTo('gameplayMobile')" alt="" class="w-[14.2vw]">
          <img ref="buttonOpen" src="./assets/img/Mobile/menu.webp" alt="" class="w-[7.5vw] h-[7.4vw]">
        </div>
        <div ref="navbarOpen"
          class="fixed top-[3vw] transition-all duration-500 ease-in-out backdrop-blur-ip w-[95vw] h-[48vw] rounded-[3vw] px-[2.8vw] flex bg-[#00191D30] backdrop-blur-[6vw] py-[1.4vw] flex-col justify-between hidden z-50">
          <div class="flex flex-row w-[90vw] h-[7.4vw] justify-between">
            <img src="./assets/img/Desktop/LogoNav/1.webp" @click="scrollTo('gameplayMobile')" alt=""
              class="w-[14.2vw]">
            <img ref="buttonClose" src="./assets/img/Mobile/close.webp" alt="" class="w-[7.5vw] h-[7.4vw]">
          </div>
          <div class="text-white flex flex-row text-[3.72vw] font-league font-black space-x-[2vw] ml-[2vw]">
            <p class="" @click="scrollTo('featureMobile')">Feature</p>
            <p class="">|</p>
            <p class="" @click="scrollTo('gameplayMobile')">Gameplay</p>
            <p class="">|</p>
            <p class="" @click="scrollTo('community')">Community</p>
          </div>
          <div class="flex flex-row justify-between w-[35.5vw] h-[9.3vw] ml-[2vw]">
            <img src="./assets/img/Desktop/StartJourney/Telegram.webp" alt="" class="w-[9.3vw] h-[9.3vw]"
              @click="openWebLink('https://t.me/idleglory_group')">
            <img src="./assets/img/Desktop/StartJourney/Telegram.webp" alt="" class="w-[9.3vw] h-[9.3vw]"
              @click="openWebLink('https://t.me/idleglory_channel')">
            <img src="./assets/img/Desktop/StartJourney/prime_twitter.webp" alt="" class="w-[9.3vw] h-[9.3vw]"
              @click="openWebLink('https://x.com/idle_gIory')">
          </div>
          <div class="w-[90vw] h-[10.4vw] flex items-end justify-end mb-[1vw]">
            <img src="./assets/img/Desktop/LogoNav/ButtonPlayNow.png" alt="" class="w-[33.1vw] h-[10.4vw]" @click="openWebLink('https://play.idle-glory.io/')">
          </div>
        </div>


        <!-- Content mobile -->
        <div class="w-full h-auto flex flex-col">
          <HomeMobile id="gameplayMobile" />
          <TopIdleMobile />
          <DeepStrategyMobile />
          <ConquerWorldMobile id="featureMobile" />
          <FirestormArenaMobile />
          <ChallengenMobile id="community" />
          <MobileFooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import HomeDesk from './components/Desktop/HomeDesk.vue';
import TopIdlePowers from "./components/Desktop/TopIdlePowers.vue";
import DeepStrategy from "./components/Desktop/DeepStrategy.vue";
import SummonLegend from "./components/Desktop/SummonLegend.vue";
import ConquerWorld from "./components/Desktop/ConquerWorld.vue";
import FirestormArena from "./components/Desktop/FirestormArena.vue";
import DesktopFooter from "./components/Desktop/DesktopFooter.vue";
import HomeMobile from "./components/Mobile/HomeMobile.vue";
import TopIdleMobile from "./components/Mobile/TopIdleMobile.vue";
import DeepStrategyMobile from "./components/Mobile/DeepStrategy.vue";
import ConquerWorldMobile from "./components/Mobile/ConquerWorld.vue";
import FirestormArenaMobile from "./components/Mobile/FirestormArena.vue";
import ChallengenMobile from "./components/Mobile/ChallengenMobile.vue";
import MobileFooter from "./components/Mobile/MobileFooter.vue";

export default {
  name: 'App',
  setup() {
    const homeFrame = ref(null);
    const gamePlay = ref(null);
    const windowWidth = ref(window.innerWidth);
    const isMobile = computed(() => windowWidth.value <= 768);
    const initialIsMobile = ref(isMobile.value);

    const navbarClose = ref(null);
    const navbarOpen = ref(null);
    const buttonOpen = ref(null);
    const buttonClose = ref(null);


    const handleResize = () => {
      windowWidth.value = window.innerWidth;
      if (isMobile.value !== initialIsMobile.value) {
        initialIsMobile.value = isMobile.value;
      }
    };

    const openNavbar = () => {
      navbarClose.value.classList.add("hidden");
      navbarOpen.value.classList.remove("hidden");
    };

    function openWebLink(url) {
      setTimeout(() => {
        window.open(url, "_blank");
      }, 300);
    }

    const closeNavbar = () => {
      navbarOpen.value.classList.add("hidden");
      navbarClose.value.classList.remove("hidden");
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);

      buttonOpen.value.addEventListener("click", openNavbar);
      buttonClose.value.addEventListener("click", closeNavbar);
    });


    // Check when change width
    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    return {
      homeFrame,
      isMobile,
      gamePlay,
      initialIsMobile,
      navbarClose,
      navbarOpen,
      buttonOpen,
      buttonClose,
      openWebLink
    };
  },
  components:
  {
    HomeDesk,
    TopIdlePowers,
    DeepStrategy,
    SummonLegend,
    ConquerWorld,
    FirestormArena,
    DesktopFooter,
    // Mobile
    HomeMobile,
    TopIdleMobile,
    DeepStrategyMobile,
    ConquerWorldMobile,
    FirestormArenaMobile,
    ChallengenMobile,
    MobileFooter
  },
  methods: {
    scrollTo(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        console.warn(`Không tìm thấy phần tử với id: ${sectionId}`);
      }
    },
  },
}
</script>

<style>
@font-face {
  font-family: "Emeritus";
  src: url(../src/assets/fonts/Emeritus-Bold.ttf);
}

@font-face {
  font-family: "LeagueSpartan";
  src: url(../src/assets/fonts/LeagueSpartan-VariableFont_wght.ttf);
}
@font-face {
  font-family: "Inter";
  src: url(../src/assets/fonts/Inter-VariableFont_opsz,wght.ttf);
}

.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.font-inter {
  font-family: "Inter", sans-serif;
}

body {
  background-color: #171717;
}

html {
  scroll-behavior: smooth;
}

html,
body {
  overflow-y: scroll;
  scrollbar-width: none;
}

html::-webkit-scrollbar {
  display: none; 
}

.backdrop-blur-ip{
    backdrop-filter: blur(3vw);
    -webkit-backdrop-filter: blur(3vw);
}
</style>
